export const PICKLEJAR_DEFAULT_LOGIN_URL = '/login';
export const PICKLEJAR_DEFAULT_PROFILE_PAGE_URL = '/profile';
export const PICKLEJAR_DEFAULT_CLAIMS_PAGE_URL = '/claims';
export const PICKLEJAR_DEFAULT_GO_BACK_PROFILE_PAGE_URL = PICKLEJAR_DEFAULT_CLAIMS_PAGE_URL;
